import React, { useEffect } from 'react';
import { UrgencyBar } from './components/UrgencyBar';
import { Hero } from './components/Hero';
import { Hook } from './components/Hook';
import { PainPoints } from './components/PainPoints';
import { Revelation } from './components/Revelation';
import { OfferStack } from './components/OfferStack';
import { Testimonial } from './components/Testimonial';
import { Guarantee } from './components/Guarantee';
import { Faq } from './components/Faq';
import { FinalCta } from './components/FinalCta';
import { Footer } from './components/Footer';
import { META_PIXEL_ID } from './data/offer';
import { initMetaPixel } from './utils/metaPixel';
export function App() {
  useEffect(() => {
    initMetaPixel(META_PIXEL_ID);
  }, []);
  return <div className="w-full bg-white font-sans" data-id="element-0" data-mp="2wip5j08ate3v">
      <UrgencyBar data-id="element-1" data-mp="28tw5osok2m3z" />
      <main data-id="element-2" data-mp="28te1n9vnj3li">
        <Hero data-id="element-3" data-mp="28t4j27cxrypu" />
        <Hook data-id="element-4" data-mp="28sl511qepuh3" />
        <PainPoints data-id="element-5" data-mp="28s2x37udtrtc" />
        <Revelation data-id="element-6" data-mp="23vkuoemiy5k6" />
        <OfferStack data-id="element-7" data-mp="23w4clvc6cty7" />
        <Testimonial data-id="element-8" data-mp="23utcq6luo6cd" />
        <Guarantee data-id="element-9" data-mp="23t8g8bfz6dbv" />
        <Faq data-id="element-10" data-mp="3ijxoypkvdyjd" />
        <FinalCta data-id="element-11" data-mp="3ikh829m9asyz" />
      </main>
      <Footer data-id="element-12" data-mp="3ij65ue8glt9z" />
    </div>;
}